export default {
  "login": "taylorotwell",
  "id": 463230,
  "node_id": "MDQ6VXNlcjQ2MzIzMA==",
  "avatar_url": "https://avatars.githubusercontent.com/u/463230?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/taylorotwell",
  "html_url": "https://github.com/taylorotwell",
  "followers_url": "https://api.github.com/users/taylorotwell/followers",
  "following_url": "https://api.github.com/users/taylorotwell/following{/other_user}",
  "gists_url": "https://api.github.com/users/taylorotwell/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/taylorotwell/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/taylorotwell/subscriptions",
  "organizations_url": "https://api.github.com/users/taylorotwell/orgs",
  "repos_url": "https://api.github.com/users/taylorotwell/repos",
  "events_url": "https://api.github.com/users/taylorotwell/events{/privacy}",
  "received_events_url": "https://api.github.com/users/taylorotwell/received_events",
  "type": "User",
  "site_admin": false,
  "name": "Taylor Otwell",
  "company": "Laravel",
  "blog": "http://laravel.com",
  "location": "Little Rock, AR",
  "email": null,
  "hireable": null,
  "bio": "Creator of @laravel.",
  "twitter_username": null,
  "public_repos": 17,
  "public_gists": 9,
  "followers": 21153,
  "following": 0,
  "created_at": "2010-11-01T20:15:30Z",
  "updated_at": "2021-01-27T13:59:33Z"
}